import { Component, OnInit, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { UserRole, Modules, AccessRights, DemandeStatus } from '../../utils/enumeration';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../../services/authentication.service';
import { Router, NavigationEnd } from '@angular/router';
import { AppComponent } from '../../app.component';
import { ConnectedUserComponent } from '../connectedUserComponent';
import { Subscription } from 'rxjs';
import { Statique } from '../../utils/statique';
import { ShowOnDirtyErrorStateMatcher } from '@angular/material';

@Component({
	selector: 'app-side-bar',
	templateUrl: './side-bar.component.html',
	styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent extends ConnectedUserComponent implements OnInit {

	isLoggedInScalar: boolean;
	Modules = Modules;
	UserRole = UserRole;
	isLoggedIn: Observable<boolean>;
	@Input() module: number = null;
	url: string = "";
	private subscription: Subscription;
	@Input() show : boolean;

	constructor(
		myElement: ElementRef,
		protected authenticationService: AuthenticationService,
		private router: Router,
		protected cd: ChangeDetectorRef
	) {
		super();
	}
	
	ngAfterViewInit() {
		this.cd.detectChanges();
	}
	getIdURL():string{
		return window.location.href.split("app/")[1]!=null?  window.location.href.split("app/")[1].split("?")[0]: '';
	}

	ngOnInit() {
		this.isLoggedInScalar = AuthenticationService.isAuthenticated();
		this.authenticationService.connectedUser.subscribe(tocken => {
			this.isLoggedInScalar = tocken != null;
		});

		this.subscription = this.authenticationService.sideBarInitUserObservale.subscribe((res) =>
			this.checkChange()
		);

		document.addEventListener("click", this.quicknavItemClickHandler);
	}

	goToCreationPricing()
	{
		this.router.navigate(['/app/pricing/creation'],{ queryParams: { page: (new Date().getTime()) .toString(36) } });
	}
	goToEtatAQuai()
	{
		this.router.navigate(['/app/pricing/etataquai'],{ queryParams: { page: (new Date().getTime()) .toString(36) } });
	}
	menuToggle(event) {
		let myElement = document.getElementById("sidebar_left");
		//let body = document.getElementById("body_content")
		let body = document.getElementsByClassName("app-wrapper")[0];
		// myElement.classList.toggle("closed");
		// body.classList.toggle("opened");

		if (myElement.classList.contains("closed")) {
			body.classList.remove("opened");
			myElement.classList.remove("closed");

			let quicknav = document.getElementById("quicknav");
			let els = quicknav.getElementsByClassName("active");
			if (els && els.length > 1) {
				els[1].classList.remove("active");
				els[0].classList.remove("active");
			}
			let it;
			(it = quicknav.getElementsByTagName("ul")[0].children[0].children[0]) ? it.classList.add("active") : null;
			(it = quicknav.getElementsByClassName("tab-content")[0].children[0]) ? it.classList.add("active") : null;

		} else {
			body.classList.add("opened");
			myElement.classList.add("closed");

			let quicknav = document.getElementById("quicknav");
			let els = quicknav.getElementsByClassName("active");
			if (els && els.length > 1) {
				els[1].classList.remove("active");
				els[0].classList.remove("active");
			}
		}
		// remove active class after closing sidebar
		let it;
		it = document.getElementById("quicknav").getElementsByTagName("li")[0].getElementsByClassName("active")[0];
		if (it != undefined) {
			if (it.classList.contains("active")) {
				it.classList.remove("active")
			}
		}
	}

	async quicknavItemClickHandler(evt) {
		let $el = evt.target;
		let it;

		try {
			let sideBarLeftEl = await Statique.waitUntilElementExists("#sidebar_left");
			let quicknav = await Statique.waitUntilElementExists("#quicknav");

			if (document.getElementById("sidebar_left").classList.contains("closed") && !$el.classList.contains("nav-item") && !$el.classList.contains("nav-link") && !$el.classList.contains("fa")) {
				(it = document.getElementById("quicknav").getElementsByTagName("ul")[0].getElementsByClassName("active")[0]) ? it.classList.remove("active") : null;
				(it = document.getElementById("quicknav").getElementsByClassName("tab-content")[0].getElementsByClassName("active")[0]) ? it.classList.remove("active") : null;
			}
		}
		catch (e) { }
	}

	closeTab(event: any) {
		let it;
		if (document.getElementById("sidebar_left").classList.contains("closed")) {
			it = document.getElementById("quicknav").getElementsByTagName("li")[0].getElementsByClassName("active")[0];
			if (it != undefined) {
				if (it.classList.contains("active")) {
					it.classList.remove("active")
				}
			}

			it = document.getElementById("quicknav").getElementsByClassName("tab-content")[0].getElementsByClassName("active")[0]
			if (it != undefined) {
				if (it.classList.contains("active")) {
					it.classList.remove("active")
				}
			}

		}

	}
	toggleActive(el) {
		el.classList.toggle("open");
	}

	makeActive(path) {
		if (path == "accueil")
			return this.router.url.indexOf('/app') < 0 ? "active" : "";
		return this.router.url.indexOf(path) >= 0 ? "active" : "";
	}

	isDocumentsSubmenuOpen() {
		return this.router.url.indexOf('/compliance-matrix') >= 0 ? "open" : "";
	}

	isContribution(ecModule: number) {
		let acc = this.userConnected.listAccessRights.find(access => {
			if (access.module.ecModuleNum == ecModule && access.accessRight == AccessRights.CONTRIBUTION)
				return true;
		}) ? true : false;
		return acc;
	}
	hasAccesUrl(patch: String){
		if(this.router.url==patch)
			return true;
		return false;
	}
	hasAccess(ecModule: number) {
		let acc = this.userConnected.listAccessRights.find(access => {
			if (access.module.ecModuleNum == ecModule && access.accessRight == AccessRights.NON_VISIBLE)
				return true;
		}) ? false : true;
		return acc;
	}

	getDashboardPath(module: number) {
		return "/app/" + Statique.moduleNamePath[Statique.getModuleNameByModuleNum(module)] + "/dashboard";
	}

	emitClickCancelPricing($event){
		let event = new CustomEvent('cancel-pricing', {detail: $event});
		document.dispatchEvent(event);
	}

	emitClickNewEvent() {
		let event = new CustomEvent('new-event', null);
		document.dispatchEvent(event);
	}

	canShowCancelButton(){
		let status : number = +localStorage.getItem("xEcStatut");
		return this.module == Modules.PRICING && this.isChargeur && this.isContribution(Modules.PRICING) && window.location.href.indexOf('/details/') >= 0 && status >= DemandeStatus.IN_PROCESS && status < DemandeStatus.FINAL_CHOICE;
	}

	emitClickNewDeviation() {
		let event = new CustomEvent('new-deviation', null);
		document.dispatchEvent(event);
	}

	emitClickPopUp() {
		let event = new CustomEvent('btnPopUp', null);
		document.dispatchEvent(event);
	}

	// toggle select icons
	onSelectOpen() {
		var open = false;
		// just a function to print out message
		function isOpen() {
			if (open)
				return "menu is open";
			else
				return "menu is closed";
		}
		// on each click toggle the "open" variable
		$("select").on("click", function () {
			open = !open;
			console.log(isOpen());
		});
		// on each blur toggle the "open" variable
		// fire only if menu is already in "open" state
		$("select").on("blur", function () {
			if (open) {
				open = !open;
				console.log(isOpen());
			}
		});
		// on ESC key toggle the "open" variable only if menu is in "open" state
		$(document).keyup(function (e) {
			if (e.keyCode == 27) {
				if (open) {
					open = !open;
					console.log(isOpen());
				}
			}
		});
	}

	ngOnDestroy() {
		document.removeEventListener("click", this.quicknavItemClickHandler);
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/side-bar/side-bar.component.ts